import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import NavPills from "../../../components/NavPills/NavPills.jsx";

import pillsStyle from "../../../assets/jss/material-kit-pro-react/views/componentsSections/pillsStyle.jsx";

/**
 * TODO: Actualizar los links con los videos de Como Reservar
 */

class SectionPills extends Component {
    render() {
        const { classes, touristsTerms } = this.props;
        
        return (
            <div className={classes.section}>
                <div className={classes.container}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} lg={12}>
                            <NavPills
                                color="success"
                                tabs={[
                                    {
                                        tabButton: "Términos y Condiciones",
                                        // tabIcon: LocalFlorist,
                                        tabContent: (
                                            <div dangerouslySetInnerHTML={{ __html: touristsTerms }} />
                                        )
                                    }
                                ]}
                            />
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        );
    }
}

export default withStyles(pillsStyle)(SectionPills);



// WEBPACK FOOTER //
// ./src/views/TermsPage/Sections/SectionPills.jsx